import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, TemplateRef, ContentChild, Output, Input, ViewEncapsulation, Component } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import * as i2 from 'primeng/accordion';
import { AccordionModule } from 'primeng/accordion';
import * as i4 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i3 from 'primeng/api';
function FooterMenuComponent_p_accordionTab_3_ng_template_1__svg_svg_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 13);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#expand-more");
  }
}
function FooterMenuComponent_p_accordionTab_3_ng_template_1__svg_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 13);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#expand-less");
  }
}
function FooterMenuComponent_p_accordionTab_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FooterMenuComponent_p_accordionTab_3_ng_template_1__svg_svg_0_Template, 2, 2, "svg", 12)(1, FooterMenuComponent_p_accordionTab_3_ng_template_1__svg_svg_1_Template, 2, 2, "svg", 12);
  }
  if (rf & 2) {
    const i_r3 = i0.ɵɵnextContext().index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i_r3 !== ctx_r1.activeTabIndex);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r3 === ctx_r1.activeTabIndex);
  }
}
function FooterMenuComponent_p_accordionTab_3_p_2_a_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 19);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#north-east");
  }
}
function FooterMenuComponent_p_accordionTab_3_p_2_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, FooterMenuComponent_p_accordionTab_3_p_2_a_1__svg_svg_2_Template, 2, 2, "svg", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", item_r4 == null ? null : item_r4.url, i0.ɵɵsanitizeUrl)("target", ctx_r1.getItemTarget(item_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r4 == null ? null : item_r4.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getItemTarget(item_r4) === "_blank");
  }
}
function FooterMenuComponent_p_accordionTab_3_p_2_a_2__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 19);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#north-east");
  }
}
function FooterMenuComponent_p_accordionTab_3_p_2_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, FooterMenuComponent_p_accordionTab_3_p_2_a_2__svg_svg_2_Template, 2, 2, "svg", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", item_r4 == null ? null : item_r4.routerLink)("target", ctx_r1.getItemTarget(item_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r4 == null ? null : item_r4.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getItemTarget(item_r4) === "_blank");
  }
}
function FooterMenuComponent_p_accordionTab_3_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 14);
    i0.ɵɵtemplate(1, FooterMenuComponent_p_accordionTab_3_p_2_a_1_Template, 3, 4, "a", 15)(2, FooterMenuComponent_p_accordionTab_3_p_2_a_2_Template, 3, 4, "a", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isItemExternal(item_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isItemExternal(item_r4));
  }
}
function FooterMenuComponent_p_accordionTab_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-accordionTab", 9);
    i0.ɵɵtemplate(1, FooterMenuComponent_p_accordionTab_3_ng_template_1_Template, 2, 2, "ng-template", 10)(2, FooterMenuComponent_p_accordionTab_3_p_2_Template, 3, 2, "p", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵproperty("header", item_r5 == null ? null : item_r5.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r5 == null ? null : item_r5.items);
  }
}
function FooterMenuComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FooterMenuComponent_div_7_span_3_a_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 19);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#north-east");
  }
}
function FooterMenuComponent_div_7_span_3_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, FooterMenuComponent_div_7_span_3_a_1__svg_svg_2_Template, 2, 2, "svg", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", item_r6 == null ? null : item_r6.url, i0.ɵɵsanitizeUrl)("target", ctx_r1.getItemTarget(item_r6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r6 == null ? null : item_r6.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getItemTarget(item_r6) === "_blank");
  }
}
function FooterMenuComponent_div_7_span_3_a_2__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 19);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#north-east");
  }
}
function FooterMenuComponent_div_7_span_3_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, FooterMenuComponent_div_7_span_3_a_2__svg_svg_2_Template, 2, 2, "svg", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", item_r6 == null ? null : item_r6.routerLink)("target", ctx_r1.getItemTarget(item_r6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r6 == null ? null : item_r6.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getItemTarget(item_r6) === "_blank");
  }
}
function FooterMenuComponent_div_7_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtemplate(1, FooterMenuComponent_div_7_span_3_a_1_Template, 3, 4, "a", 15)(2, FooterMenuComponent_div_7_span_3_a_2_Template, 3, 4, "a", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isItemExternal(item_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isItemExternal(item_r6));
  }
}
function FooterMenuComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "span", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FooterMenuComponent_div_7_span_3_Template, 3, 2, "span", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r7 == null ? null : item_r7.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r7 == null ? null : item_r7.items);
  }
}
function FooterMenuComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FooterMenuComponent_ng_template_10_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 19);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r1.facebookUrl, i0.ɵɵsanitizeUrl)("title", ctx_r1.facebookTitle ? ctx_r1.facebookTitle : "facebook social");
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#facebook");
  }
}
function FooterMenuComponent_ng_template_10_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 19);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r1.linkedInUrl, i0.ɵɵsanitizeUrl)("title", ctx_r1.linkedInTitle ? ctx_r1.linkedInTitle : "linkedIn social");
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#linkedin");
  }
}
function FooterMenuComponent_ng_template_10_a_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 19);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r1.xUrl, i0.ɵɵsanitizeUrl)("title", ctx_r1.xUrlTitle ? ctx_r1.xUrlTitle : "xUrl social");
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#x");
  }
}
function FooterMenuComponent_ng_template_10_a_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 19);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r1.instagramUrl, i0.ɵɵsanitizeUrl)("title", ctx_r1.instagramTitle ? ctx_r1.instagramTitle : "instagram social");
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#instagram");
  }
}
function FooterMenuComponent_ng_template_10_a_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 19);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r1.youtubeUrl, i0.ɵɵsanitizeUrl)("title", ctx_r1.youtubeTitle ? ctx_r1.youtubeTitle : "youtube social");
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#youtube");
  }
}
function FooterMenuComponent_ng_template_10_a_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 19);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r1.pinterestUrl, i0.ɵɵsanitizeUrl)("title", ctx_r1.pinterestTitle ? ctx_r1.pinterestTitle : "pinterest social");
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#pinterest");
  }
}
function FooterMenuComponent_ng_template_10_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FooterMenuComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, FooterMenuComponent_ng_template_10_a_1_Template, 3, 4, "a", 26)(2, FooterMenuComponent_ng_template_10_a_2_Template, 3, 4, "a", 26)(3, FooterMenuComponent_ng_template_10_a_3_Template, 3, 4, "a", 26)(4, FooterMenuComponent_ng_template_10_a_4_Template, 3, 4, "a", 26)(5, FooterMenuComponent_ng_template_10_a_5_Template, 3, 4, "a", 26)(6, FooterMenuComponent_ng_template_10_a_6_Template, 3, 4, "a", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 27)(8, "p-button", 28);
    i0.ɵɵlistener("click", function FooterMenuComponent_ng_template_10_Template_p_button_click_8_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onContactUsClick($event));
    });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, FooterMenuComponent_ng_template_10_ng_container_10_Template, 1, 0, "ng-container", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.facebookUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.linkedInUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.xUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.instagramUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.youtubeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pinterestUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("outlined", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.contactText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.mediaTpl);
  }
}
let FooterMenuComponent = /*#__PURE__*/(() => {
  class FooterMenuComponent {
    constructor() {
      this.menuItems = [];
      this.facebookUrl = '';
      this.facebookTitle = '';
      this.linkedInUrl = '';
      this.linkedInTitle = '';
      this.xUrl = '';
      this.xUrlTitle = '';
      this.instagramUrl = '';
      this.instagramTitle = '';
      this.youtubeUrl = '';
      this.youtubeTitle = '';
      this.pinterestUrl = '';
      this.pinterestTitle = '';
      this.contactText = 'Contact Us';
      this.contactUsClick = new EventEmitter();
      this.activeTabIndex = -1;
      this.icons = 'assets/pds-icons.svg';
    }
    onContactUsClick($event) {
      this.contactUsClick.emit($event);
    }
    onTabOpen(event) {
      this.activeTabIndex = event.index;
    }
    onTabClose(event) {
      this.activeTabIndex = -1;
    }
    isItemExternal(i) {
      return i?.url && !i?.routerLink;
    }
    getItemTarget(i) {
      if (i && i.target) {
        return i.target;
      } else if (i && !i.target && i.url) {
        return '_blank';
      } else {
        return '_self';
      }
    }
    static {
      this.ɵfac = function FooterMenuComponent_Factory(t) {
        return new (t || FooterMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FooterMenuComponent,
        selectors: [["pds-footer-menu"]],
        contentQueries: function FooterMenuComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mediaTpl = _t.first);
          }
        },
        inputs: {
          menuItems: "menuItems",
          facebookUrl: "facebookUrl",
          facebookTitle: "facebookTitle",
          linkedInUrl: "linkedInUrl",
          linkedInTitle: "linkedInTitle",
          xUrl: "xUrl",
          xUrlTitle: "xUrlTitle",
          instagramUrl: "instagramUrl",
          instagramTitle: "instagramTitle",
          youtubeUrl: "youtubeUrl",
          youtubeTitle: "youtubeTitle",
          pinterestUrl: "pinterestUrl",
          pinterestTitle: "pinterestTitle",
          contactText: "contactText"
        },
        outputs: {
          contactUsClick: "contactUsClick"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: ActivatedRoute,
          useValue: {}
        }]), i0.ɵɵStandaloneFeature],
        decls: 12,
        vars: 5,
        consts: [["socialTemplate", ""], [1, "pds-footer-menu-compact"], [1, "pds-footer-menu-container"], [3, "onOpen", "onClose", "activeIndex"], ["iconPos", "end", 3, "header", 4, "ngFor", "ngForOf"], [4, "ngTemplateOutlet"], [1, "pds-footer-menu-desktop"], ["class", "pds-footer-menu-column", 4, "ngFor", "ngForOf"], [1, "pds-footer-social-contact-wrapper"], ["iconPos", "end", 3, "header"], ["pTemplate", "icon"], ["class", "pds-footer-menu-item", 4, "ngFor", "ngForOf"], ["class", "pds-icon p-accordion-toggle-icon-end", 4, "ngIf"], [1, "pds-icon", "p-accordion-toggle-icon-end"], [1, "pds-footer-menu-item"], [3, "href", "target", 4, "ngIf"], [3, "routerLink", "target", 4, "ngIf"], [3, "href", "target"], ["class", "pds-icon", 4, "ngIf"], [1, "pds-icon"], [3, "routerLink", "target"], [1, "pds-footer-menu-column"], [1, "pds-footer-menu-column-heading"], ["class", "pds-footer-menu-column-item", 4, "ngFor", "ngForOf"], [1, "pds-footer-menu-column-item"], [1, "pds-footer-social-bar"], ["target", "_blank", "class", "pds-footer-social-bar-icon", 3, "href", "title", 4, "ngIf"], [1, "pds-footer-contact"], [3, "click", "outlined"], ["target", "_blank", 1, "pds-footer-social-bar-icon", 3, "href", "title"]],
        template: function FooterMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "p-accordion", 3);
            i0.ɵɵlistener("onOpen", function FooterMenuComponent_Template_p_accordion_onOpen_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTabOpen($event));
            })("onClose", function FooterMenuComponent_Template_p_accordion_onClose_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTabClose($event));
            });
            i0.ɵɵtemplate(3, FooterMenuComponent_p_accordionTab_3_Template, 3, 2, "p-accordionTab", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, FooterMenuComponent_ng_container_4_Template, 1, 0, "ng-container", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 6)(6, "div", 2);
            i0.ɵɵtemplate(7, FooterMenuComponent_div_7_Template, 4, 2, "div", 7);
            i0.ɵɵelementStart(8, "div", 8);
            i0.ɵɵtemplate(9, FooterMenuComponent_ng_container_9_Template, 1, 0, "ng-container", 5);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(10, FooterMenuComponent_ng_template_10_Template, 11, 9, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const socialTemplate_r9 = i0.ɵɵreference(11);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("activeIndex", ctx.activeTabIndex);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.menuItems);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", socialTemplate_r9);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.menuItems);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", socialTemplate_r9);
          }
        },
        dependencies: [CommonModule, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, AccordionModule, i2.Accordion, i2.AccordionTab, i3.PrimeTemplate, ButtonModule, i4.Button, RouterLink],
        encapsulation: 2
      });
    }
  }
  return FooterMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { FooterMenuComponent };
